import { formatStringAsDate } from 'helpers/dateFormatters'
import { differenceInCalendarDays } from 'date-fns'
import { ACCOUNT_OPEN } from 'const/account/conditions'
import { PSCC, RC } from 'const/account/products'
import {
  AllAccountSummaryGetResponse,
  ProfileGetResponse
} from 'const/syfApiQueries'
import { NotificationAccount } from '../typings/notifications'

const CIPHER_ANNUAL_INCOME_LAST_UPDATED = 'cipher.annualIncomeLastUpdated'
const getAccountsForAnnualIncomeUpdate = (
  allProfileResponseData: ProfileGetResponse[],
  allAccountSummaryData: AllAccountSummaryGetResponse[]
) => {
  const accounts: NotificationAccount[] = []
  allProfileResponseData.forEach((profileData) => {
    const summaryData = allAccountSummaryData.find(
      (item) => item?.accountId === profileData?.accountId
    )
    const isRevolving = [RC, PSCC].includes(
      summaryData?.product?.lineOfBusiness
    )
    const isAccountStatusOpen = summaryData?.conditions?.includes(ACCOUNT_OPEN)

    if (isRevolving && isAccountStatusOpen) {
      const annualIncomeLastUpdatedDate =
        profileData.profile?.[CIPHER_ANNUAL_INCOME_LAST_UPDATED] &&
        formatStringAsDate(
          profileData?.profile[CIPHER_ANNUAL_INCOME_LAST_UPDATED],
          '/'
        )
      const profileLastUpdateDays = annualIncomeLastUpdatedDate
        ? differenceInCalendarDays(new Date(), annualIncomeLastUpdatedDate)
        : 241

      if (profileLastUpdateDays > 240) {
        accounts.push({
          accountId: profileData?.accountId,
          accountName: profileData?.accountName
        })
      }
    }
  })
  return accounts
}

export default getAccountsForAnnualIncomeUpdate
